package pt.at.oss.kotlin.manual.storage.common.websites

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * WebsitesEntry Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class WebsitesEntry(
    var name: String = ""
) : BaseRecord()
